import "./style.css";
// Creator : Team d - oriya

export default function SelectInput({
  required = true,
  title = "Initial title",
  legend = "Initial legend",
  placeholder = "Initial placeholder",
  options = [],
  onChange
}) {
  const border = required ? "" : "invalid";
  const label = required ? "" : "invalidlabel";
  // const placeholder = required ? "" : "invalidtext";
  let ref = "";
  return (
    <>
      <fieldset className={border}>
        <legend className={label}>{legend}</legend>
        <select className="option" onChange={(e)=>{onChange(e)}}>
          <option value="-1">{placeholder}</option>
          {options.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </fieldset>
    </>
  );
}
